export default class WalkthroughPopup {
  private _name: string;
  private _userHasSeen: boolean;

  constructor(name: string, userHasSeen: boolean) {
    this._name = name;
    this._userHasSeen = userHasSeen;
  }

  get name(): string {
    return this._name;
  }

  set name(name: string) {
    this._name = name;
  }

  get userHasSeen(): boolean {
    return this._userHasSeen;
  }

  set userHasSeen(value: boolean) {
    this._userHasSeen = value;
  }

  toObject(): { name: string; userHasSeen: boolean } {
    return {
      name: this.name,
      userHasSeen: this.userHasSeen,
    };
  }
}